import LimitedAccess from './LimitedAccess';

export default LimitedAccess;
